module.exports = "../study/imgs/maps/Tokyo/S8/Ecosystem/Qacuta/Tokyo_Qacuta_GFDL_RCP26_Mid.png";